var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTopicLinear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.805 5.754a.57.57 0 0 1 .402.973l-.883.885a.582.582 0 0 1-.403.166h-9.9a2 2 0 0 0-2 2v13.198a2 2 0 0 0 2 2h13.17a2 2 0 0 0 2-2v-3.85c0-.152.062-.294.167-.403l.883-.886a.57.57 0 0 1 .971.403V23a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V9.754a4 4 0 0 1 4-4zm5.517-.495 4.42 4.426a.886.886 0 0 1 0 1.251l-11.49 11.506a.883.883 0 0 1-.626.26h-4.419a.884.884 0 0 1-.884-.886v-4.425c0-.235.093-.46.26-.626L23.071 5.259a.883.883 0 0 1 1.25 0zm-.625 1.878-10.606 10.62v3.174h3.17l10.605-10.62-3.169-3.174z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopicLinear);
export default __webpack_public_path__ + "static/media/iconTopicLinear.702db699.svg";
export { ForwardRef as ReactComponent };